// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Osdk","controls":"styles_controls__1HEdP","charLimit":"styles_charLimit__28bzq","input":"styles_input__UKAST","send":"styles_send__1Wtmz"};